import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=08ebd844&"
import script from "./Table.vue?vue&type=script&lang=ts&"
export * from "./Table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08ebd844')) {
      api.createRecord('08ebd844', component.options)
    } else {
      api.reload('08ebd844', component.options)
    }
    module.hot.accept("./Table.vue?vue&type=template&id=08ebd844&", function () {
      api.rerender('08ebd844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/Thing/Table.vue"
export default component.exports